import ReactDOM from "react-dom";
import React from "react";
import { ThemeProvider } from "styled-components";
import {
  ThemeProvider as MaterialThemeProvider,
  StylesProvider,
} from "@material-ui/core/styles";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";
import { createFirestoreInstance } from "redux-firestore";
import * as serviceWorker from "./serviceWorker";
import firebase from "./firebase";

import { theme, materialTheme } from "./utils/theme";
import GlobalStyles from "./utils/global";
import createStore from "./store";

import App from "./App";

// react-redux-firebase config
const rrfConfig = {
  userProfile: "users",
  useFirestoreForProfile: true, // Firestore for Profile instead of Realtime DB
  // attachAuthIsReady: true, // attaches auth is ready promise to store
};
const store = createStore();

const clientId =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_PAYPAL_SANDBOX
    : process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PAYPAL_PROD
    : null;

const payPalScript = document.createElement("script");

payPalScript.setAttribute(
  "src",
  `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=EUR`
);
// Setting async attribute to async load script
payPalScript.setAttribute("async", "");

document.body.appendChild(payPalScript);

ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider
      firebase={firebase}
      config={rrfConfig}
      dispatch={store.dispatch}
      createFirestoreInstance={createFirestoreInstance}
    >
      <BrowserRouter>
        <MaterialThemeProvider theme={materialTheme}>
          <ThemeProvider theme={theme}>
            <StylesProvider injectFirst>
              <>
                <App />
                <GlobalStyles />
              </>
            </StylesProvider>
          </ThemeProvider>
        </MaterialThemeProvider>
      </BrowserRouter>
    </ReactReduxFirebaseProvider>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.register();
